import React, { useEffect } from "react";

import Loading from "ds/PageLoading";
import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  getIntegrations,
  integrationsLoadingSelector,
  numberOfIntegrationsSelector
} from "Reducers/integration";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import EmptyIntegrations from "./EmptyIntegrations";
import GettingStarted from "./GettingStarted";
import IntegrationList from "./IntegrationList";
import { Section } from "./IntegrationListPage.styles";
import SectionHeader from "./SectionHeader";

const ProjectIntegration = () => {
  const dispatch = useAppDispatch();
  const { projectId } = useDecodedParams<{ projectId: string }>();
  const loading = useAppSelector(integrationsLoadingSelector);
  const numberOfIntegrations = useSelectorWithUrlParams(
    numberOfIntegrationsSelector
  );

  const hasIntegrations = numberOfIntegrations > 0;
  const showGettingStartedIfHasNotBeenDisclosed = numberOfIntegrations === 1;

  useEffect(() => {
    dispatch(getIntegrations({ projectId: projectId || "" }));
  }, [dispatch, projectId]);

  if (loading) {
    return <Loading iconOnly={true} />;
  }

  return (
    <Section>
      <SectionHeader />
      {showGettingStartedIfHasNotBeenDisclosed && <GettingStarted />}
      {hasIntegrations ? <IntegrationList /> : <EmptyIntegrations />}
    </Section>
  );
};

export default ProjectIntegration;
